import { AccountType } from './../Accounts/accounts-reducer';
import { UserType } from './../Users/users-reducer';
import { cookies, saveTokenInCookies, setCurrentLocation,removeRoleinCookies, setRoleinCookies, removeTokenFromCookies, removeLocationFromCookies, removeProjectNamesFromCookies } from './../../app/cookies';
import { AppRootState } from './../../app/store';
import { fetchProjectsTC } from './../Projects/project-reducer';
import { setAppErrorAC, setAppStatusAC } from '../../app/app-reducer';
import { Dispatch } from "redux"
import { accountsAPI, authAPI } from '../../api/projects-api';
import { handleRequestResponseError } from '../../utils/errorUtils/handleServerNetworkError';
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchAllUpdatedTasks } from '../Notification/notification-reducer';


export const loginTC = createAsyncThunk('auth/getToken', async (params: { username: string, password: string }, thunkAPI) => {
  thunkAPI.dispatch(setAppStatusAC({ status: 'loading' }))
  let token: string
  let currentDate = new Date();
  let expiresAt = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), currentDate.getHours() + 2, currentDate.getMinutes(), currentDate.getSeconds())
  try {
    const res = await authAPI.getToken(params.username, params.password)
    thunkAPI.dispatch(setToken({ token: res.data.token }))
    thunkAPI.dispatch(setIsLoggedInAC({ value: true }))
    token = res.data.token as string
    saveTokenInCookies(token, expiresAt)
    thunkAPI.dispatch(fetchProjectsTC(token))
    thunkAPI.dispatch(getUserDataByLogin())
    thunkAPI.dispatch(setAppStatusAC({ status: 'succeeded' }))
  } catch (error: any) {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      console.log(error.response.status);
      const status = error.response.status
      if (status === 400) {
        thunkAPI.dispatch(setAppErrorAC({ error: "Login or password is not correct!", color: 'error' }))
      } else {
        thunkAPI.dispatch(setAppErrorAC({ error: `Something happened... Server response: ${error.response.status}`, color: 'error' }))
      }

    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
      thunkAPI.dispatch(setAppErrorAC({ error: 'Server is not available', color: 'error' }))
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log('Error', error.message);
      thunkAPI.dispatch(setAppErrorAC({ error: error.message, color: 'error' }))
    }
    //handleServerNetworkError(error.message, thunkAPI.dispatch)
    return thunkAPI.rejectWithValue({ errors: [error.message], fieldsErrors: 'wrong password or email' })
  }
})

export const logoutTC = createAsyncThunk('auth/logout', async (_, thunkAPI) => {
  thunkAPI.dispatch(setAppStatusAC({ status: 'loading' }))
  thunkAPI.dispatch(removeToken())
  removeTokenFromCookies()
  removeLocationFromCookies()
  removeProjectNamesFromCookies()
  removeRoleinCookies()
  setCurrentLocation('')
  thunkAPI.dispatch(setIsLoggedInAC({ value: false }))
  thunkAPI.dispatch(setAppStatusAC({ status: 'succeeded' }))
})

export const checkAutoLogin = (dispatch: Dispatch, isMainPage?: boolean) => {
  const token = cookies.get('token')
  if(!token) {
    dispatch(setIsLoggedInAC({value: false}))
    return null
  } else {
    dispatch(setToken({token}))
    isMainPage && dispatch(setIsLoggedInAC({value: true}))
    return token
  }
}

export const getUserData = createAsyncThunk('auth/user', async (_, thunkAPI) => {
  thunkAPI.dispatch(setAppStatusAC({ status: 'loading' }))
  const state = thunkAPI.getState() as AppRootState
  const token = state.auth.token
  try {
    const res = await authAPI.user(token)
    thunkAPI.dispatch(setMe(res.data))
    const res2= await accountsAPI.getAccount(token, res.data.accountId)
    thunkAPI.dispatch(setMyAccount(res2.data))
    setRoleinCookies(res.data.isAdminRole)
    thunkAPI.dispatch(setAppStatusAC({ status: 'succeeded' }))
  } catch (error: any) {
    handleRequestResponseError(error, thunkAPI.dispatch)
    return thunkAPI.rejectWithValue
  }
})

export const getMyAccountDataTC = createAsyncThunk('auth/myAccountData', async (params:{accountId: number}, thunkAPI) => {
  thunkAPI.dispatch(setAppStatusAC({ status: 'loading' }))
  const state = thunkAPI.getState() as AppRootState
  const token = state.auth.token
  try {
    const res = await accountsAPI.getAccount(token, params.accountId)
    
    thunkAPI.dispatch(setMyAccount(res.data))
    
    thunkAPI.dispatch(setAppStatusAC({ status: 'succeeded' }))
  } catch (error: any) {
    handleRequestResponseError(error, thunkAPI.dispatch)
    return thunkAPI.rejectWithValue
  }
})

export const getUserDataByLogin = createAsyncThunk('auth/userWithNotifications', async (_, thunkAPI) => {
  thunkAPI.dispatch(setAppStatusAC({ status: 'loading' }))
  const state = thunkAPI.getState() as AppRootState
  const token = state.auth.token
  try {
    const res = await authAPI.user(token)
    thunkAPI.dispatch(setMe(res.data))
    setRoleinCookies(res.data.isAdminRole)
    const res2= await accountsAPI.getAccount(token, res.data.accountId)
    thunkAPI.dispatch(setMyAccount(res2.data))
    thunkAPI.dispatch(fetchAllUpdatedTasks())
    thunkAPI.dispatch(setAppStatusAC({ status: 'succeeded' }))
  } catch (error: any) {
    handleRequestResponseError(error, thunkAPI.dispatch)
    return thunkAPI.rejectWithValue
  }
})

export const forgotMyPasswordTC = createAsyncThunk('auth/forgotMyPassword', async (params: { email: string }, thunkAPI) => {
  thunkAPI.dispatch(setAppStatusAC({ status: 'loading' }))
  try {
    const res = await authAPI.forgotPassword(params.email)
    thunkAPI.dispatch(setAppErrorAC({ error: `We have e-mailed you a password reset link. The link will be valid for 5 minutes!`, color: 'success' }))
    thunkAPI.dispatch(setAppStatusAC({ status: 'succeeded' }))
  } catch (error: any) {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      console.log(error.response.status);
      const status = error.response.status
      if (status === 404) {
        thunkAPI.dispatch(setAppErrorAC({ error: "User with this email is not registered!", color: 'error' }))
      } else {
        thunkAPI.dispatch(setAppErrorAC({ error: `Something happened... Server response: ${error.response.status}`, color: 'error' }))
      }

    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
      thunkAPI.dispatch(setAppErrorAC({ error: 'Server is not available', color: 'error' }))
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log('Error', error.message);
      thunkAPI.dispatch(setAppErrorAC({ error: error.message, color: 'error' }))
    }
    return thunkAPI.rejectWithValue
  }
})

export const checkResetLinkTC = createAsyncThunk('auth/checkResetLink', async (params: { data: string }, thunkAPI) => {
  thunkAPI.dispatch(setAppStatusAC({ status: 'loading' }))
  try {
    const res = await authAPI.checkResetLink(params.data)
    thunkAPI.dispatch(setIsResetLinkValid({ isLinkValid: res.data.isValid, userId: res.data.userId }))
    thunkAPI.dispatch(setAppStatusAC({ status: 'succeeded' }))
    return res.status
  } catch (error: any) {

    if (error.response) {
      console.log(error.response.status);
      const status = error.response.status
      if (status === 400) {
        thunkAPI.dispatch(setAppErrorAC({ error: "The link is not valid!", color: 'error' }))
      } else {
        thunkAPI.dispatch(setAppErrorAC({ error: `Something happened... Server response: ${error.response.status}`, color: 'error' }))
      }
    } else if (error.request) {
      console.log(error.request);
      thunkAPI.dispatch(setAppErrorAC({ error: 'Server is not available', color: 'error' }))
    } else {
      thunkAPI.dispatch(setAppErrorAC({ error: error.message, color: 'error' }))
    }
    thunkAPI.dispatch(setAppStatusAC({ status: 'succeeded' }))
    return thunkAPI.rejectWithValue({ errors: [error.message], fieldsErrors: 'the link is not valid' })
  }
})

export const updatePasswordByLinkTC = createAsyncThunk('auth/updatePasswordByLink', async (params: { newPassword: string }, thunkAPI) => {
  thunkAPI.dispatch(setAppStatusAC({ status: 'loading' }))
  const state = thunkAPI.getState() as AppRootState
  const token = state.auth.token
  const userId = state.auth.userIdToChangePassword
  try {
    const res = await authAPI.resetPasswort(userId, params.newPassword)
    res.status === 200 && thunkAPI.dispatch(setAppErrorAC({ error: `Your password is updated, please login.`, color: 'success' }))
    thunkAPI.dispatch(setAppStatusAC({ status: 'succeeded' }))
  } catch (error: any) {
    handleRequestResponseError(error, thunkAPI.dispatch)
    return thunkAPI.rejectWithValue
  }
})

const slice = createSlice({
  name: 'auth',
  initialState: {
    isLoggedIn: false,
    token: '',
    me: {} as UserType,
    isResetLinkValid: '' as isLinkValidType,
    userIdToChangePassword: 0
  },
  reducers: {
    setIsLoggedInAC(state, action: PayloadAction<{ value: boolean }>) {
      state.isLoggedIn = action.payload.value
    },
    setToken(state, action: PayloadAction<{ token: string }>) {
      state.token = action.payload.token
    },
    removeToken(state, action: PayloadAction) {
      state.token = ''
    },
    setMe(state, action: PayloadAction<UserType>) {
      state.me = action.payload
    },
    setMyAccount(state, action: PayloadAction<AccountType>) {
      state.me.account = action.payload
    },
    setIsResetLinkValid(state, action: PayloadAction<{userId: number, isLinkValid: boolean}>) {
      state.isResetLinkValid = action.payload.isLinkValid
      state.userIdToChangePassword = action.payload.userId
    },
  },
  extraReducers: builder => {
    builder.addCase(logoutTC.fulfilled, (state) => {
      state.isLoggedIn = false
  })
  }
})

export const { setIsLoggedInAC, setIsResetLinkValid, setToken, setMyAccount, removeToken,setMe} = slice.actions
export const authReducer = slice.reducer



export type isLinkValidType = boolean | string
